// src/services/works/quotationManufacturer.js
//
// 견적서 브랜드·제조사 — 견적서를 만드는 손(quotationService)과 견적서 앞단 점검(workflowService)이 같은 값을 고르게 한 곳에 둔다.
// 고르는 순서: 견적서 문서 첫 옵션의 제조사 → 설정 «제조사» → 브랜드(상품 브랜드 → 설정 «브랜드» 첫 값).
// 다 비면 '' — 지어내지 않는다. 고시 «제조자(수입자)» 도 설정 «제조사» 를 쓰므로 지어낸 값은 거짓 고시가 된다.
// 빈 채로 보내면 쿠팡 양식 productPage.manufacturer·brand(mandatory) 가 «제조사 필수»·«브랜드 필수» 로 거절한다(MCP 보고 804E1C·889CD0 · 2026-10-20).

const text = v => (typeof v === 'string' ? v.trim() : '');

/** 브랜드 — 상품 브랜드가 먼저, 없으면 설정 브랜드 · 둘 다 쉼표로 여럿이면 첫 값 */
export function firstBrandName(productBrand, settingsBrand) {
    if (text(productBrand)) return productBrand.split(',')[0].trim();
    return text(settingsBrand) ? settingsBrand.split(',')[0].trim() : '';
}

/** 견적서에 넣을 제조사 — 문서 값 → 설정 제조사 → 브랜드 · 다 비면 '' */
export function quotationManufacturer({ docManufacturer, settingsManufacturer, brandName } = {}) {
    return text(docManufacturer) || text(settingsManufacturer) || text(brandName) || '';
}

/** 견적서에 넣을 브랜드 — 견적서 문서 첫 옵션 값 → 상품 브랜드 → 설정 브랜드 첫 값 · 다 비면 '' */
export function quotationBrand({ docBrand, productBrand, settingsBrand } = {}) {
    return text(docBrand) || text(firstBrandName(productBrand, settingsBrand)) || '';
}

/**
 * 견적서 앞단 점검 — 브랜드·제조사가 비게 되면 사람 말 멈춤 글(빈 칸을 다 댄다), 아니면 null.
 * 제조사는 고시 «제조자(수입자)» 가 쓰는 값(설정 «제조사»)만 본다(옛 견적서 문서 제조사 = 브랜드 값이라 문서 값으론 안 본다) — 고시는 브랜드로 안 채운다
 * (quotationService 의 defaultNotices["제조자(수입자)"] = defaultSettings.manufacturer). 브랜드만 있는 계정은 고시가 빈 칸이라 멈춘다.
 */
export function makerFieldsMissingError(prod, defaultSettings) {
    const settings = defaultSettings || {};
    const docs = (prod && prod.coupangDoc && Array.isArray(prod.coupangDoc.jsonDocument)) ? prod.coupangDoc.jsonDocument : [];
    const page = (docs[0] && docs[0].productPage) || {};
    const brand = quotationBrand({ docBrand: page.brand, productBrand: prod && prod.brand, settingsBrand: settings.brand });
    const maker = text(settings.manufacturer);
    const empty = [];
    if (!brand) empty.push('브랜드가 비었습니다(쿠팡 필수 칸) — «브랜드»');
    if (!maker) empty.push('제조사가 비었습니다(쿠팡 필수 칸 · 고시 «제조자(수입자)» 도 같은 값) — «제조사»');
    if (!empty.length) return null;
    return `${empty.join(' · ')} — AI 로켓등록 화면 «기본설정» 에서 채운 뒤 견적서를 다시 돌리세요(runWork tasks:['quotation'])`;
}
